import globals from "@lvt/globals";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import qs from "qs";

import { SearchResult, ResultTypes, SortField, SearchIndex } from "@/utilities/types/search";


export interface VmsSearchConfig {
    filter?: {
        client_id?: number[];
        region_id?: number[];
        mounting_structure?: string[];
        indices: SearchIndex[];
    };
    sort?: Record<string,SortField>[],
    offset: number;
    limit: number;
    query: string;
}

interface Search<T> {
    meta: SearchMeta;
    results: SearchResult<T>[];
}

interface SearchMeta {
    count: number,
    max_score?: number,
    took: number,
}


type SearchResults = Search<ResultTypes>;

export interface ApiResponse<T> {
    status: number;
    status_message: string;
    data: T;
}

interface SearchRightQuery {
    indices: SearchIndex[]
}

export type SearchRightType = "stream" | "request_video";


interface SearchRightAll {
    type: "all"
}
interface SearchRightSepecific {
    type: "specific",
    clients: number[],
    entities: number[]
}

export interface SearchRights {
    is_multi_client: boolean,
    has_regions: boolean,
    stream: SearchRightAll | SearchRightSepecific,
    request_video: SearchRightAll | SearchRightSepecific,
}


export const vmsSearchApi = createApi({
    reducerPath: "vms-es",
    baseQuery: fetchBaseQuery({
        baseUrl: globals.userdashboard.proxyUrl,
        credentials: "include",
    }),
    endpoints: (builder) => ({
        vmsSearch:builder.query<ApiResponse<SearchResults>, VmsSearchConfig>({
            query: (searchConfig) => {
                const params = {
                    q: searchConfig.query,
                    limit: searchConfig.limit,
                    offset: searchConfig.offset,
                    filter : {
                        indices: searchConfig.filter?.indices ?? [],
                        client_id: searchConfig.filter?.client_id,
                        region_id: searchConfig.filter?.region_id,
                    },
                    sort: searchConfig.sort,
                };
                const query_string = qs.stringify(params, {
                    arrayFormat: "indices",
                    encode: false,
                });

                return `/api/vms/search?${query_string}`;
            },
        }),
        getVmsSearchRights: builder.query<ApiResponse<SearchRights>, SearchRightQuery> ({
            query: (searchRightsQuery) => {
                const params = {
                    indices: searchRightsQuery.indices,
                };
                const query_string = qs.stringify(params, {
                    arrayFormat: "brackets",
                    encode: false,
                });

                return `/api/vms/search/rights?${query_string}`;
            },
        }),
    }),
});

export const { useLazyVmsSearchQuery, useVmsSearchQuery, useGetVmsSearchRightsQuery, usePrefetch } = vmsSearchApi;
